<script>
import { mapGetters } from 'vuex'

export default {
  name: 'TabletBlocker',
  data() {
    return {
      collectomatePin: ''
    }
  },
  mounted() {},
  methods: {
    authorize() {
      if (this.collectomatePin == '4718') {
        this.$emit('closefn')
      } else {
        this.$error('Wrong pin')
      }
    }
  }
}
</script>

<template lang="pug">
transition(name="fade")
  .blocker
    .blocker-inner
      form(@submit.prevent="authorize")
        p {{ $t('enterPin') }}
        input.form-control.text-center.mb-3(type="password" v-model="collectomatePin")
        button.btn.btn-primary.btn-block(type="button" v-ea-click="authorize") {{ $t('authorize') }}
</template>

<style scoped lang="scss">
@import '@/assets/styles/variables.scss';

.blocker {
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;

  background: rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;

  .blocker-inner {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 20vw;
    height: 20rem;
    border-radius: 3rem;
    background: #fff;
    padding: 3rem;
    text-align: center;
    margin-bottom: 22%;
  }
  .btn {
    height: 60px;
  }
}

.fade-enter-active {
  transition: opacity 0.3s;
}

.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
